import * as api from './api'
import { alert } from '../lib/alert'
import { getItem, setItem } from '../util'

const SEEN_RELEASE_NOTE_IDS = 'li.help.seenReleaseNoteIds'

const initialState = {
  articles: {},
  articlesLoading: false,
  articlesFailed: false,
  query: '',
  uploads: [],
  uploading: false,
  requestPending: false,
  articleId: '',
  releaseNotes: [],
  seenReleaseNoteIds: getItem(SEEN_RELEASE_NOTE_IDS) || [],
}

export const SET_ARTICLES = 'HELP/SET_ARTICLES'
export const setArticles = articles => ({
  type: SET_ARTICLES,
  articles,
})

export const SET_ARTICLES_LOADING = 'HELP/SET_ARTICLES_LOADING'
export const setArticlesLoading = articlesLoading => ({
  type: SET_ARTICLES_LOADING,
  articlesLoading,
})

export const SET_ARTICLES_FAILED = 'HELP/SET_ARTICLES_FAILED'
export const setArticlesFailed = articlesFailed => ({
  type: SET_ARTICLES_FAILED,
  articlesFailed,
})

export const SET_QUERY = 'HELP/SET_QUERY'
export const setQuery = query => ({
  type: SET_QUERY,
  query,
})

export const SET_UPLOADING = 'HELP/SET_UPLOADING'
export const setUploading = uploading => ({
  type: SET_UPLOADING,
  uploading,
})

export const ADD_UPLOAD = 'HELP/ADD_UPLOAD'
export const addUpload = file => ({
  type: ADD_UPLOAD,
  file,
})

export const REMOVE_UPLOAD = 'HELP/REMOVE_UPLOAD'
export const removeUpload = file => ({
  type: REMOVE_UPLOAD,
  file,
})

export const SET_REQUEST_PENDING = 'HELP/SET_REQUEST_PENDING'
export const setRequestPending = requestPending => ({
  type: SET_REQUEST_PENDING,
  requestPending,
})

export const SET_ARTICLE_ID = 'HELP/SET_ARTICLE_ID'
export const setArticleId = articleId => ({
  type: SET_ARTICLE_ID,
  articleId,
})

export const SET_RELEASE_NOTES = 'HELP/SET_RELEASE_NOTES'
export const setReleaseNotes = releaseNotes => ({
  type: SET_RELEASE_NOTES,
  releaseNotes,
})

export const SET_SEEN_RELEASE_NOTE_IDS = 'HELP/SET_SEEN_RELEASE_NOTE_IDS'
export const setSeenReleaseNoteIds = seenReleaseNoteIds => ({
  type: SET_SEEN_RELEASE_NOTE_IDS,
  seenReleaseNoteIds,
})

export const persistSeenReleaseNoteIds = seenReleaseNoteIds => dispatch => {
  dispatch(setSeenReleaseNoteIds(seenReleaseNoteIds))
  setItem(SEEN_RELEASE_NOTE_IDS, seenReleaseNoteIds)
}

export const searchArticles = (query, helpLabel) => async dispatch => {
  try {
    dispatch(setArticlesLoading(true))
    const data = await api.searchArticles(query, helpLabel)
    dispatch(setArticles(data))
  } catch (error) {
    dispatch(setArticlesFailed(true))
  } finally {
    dispatch(setArticlesLoading(false))
  }
}

export const uploadAttachment = file => async dispatch => {
  dispatch(setUploading(true))
  const data = await api.uploadAttachment(file)
  dispatch(
    addUpload({
      name: file.name,
      error: data.error,
      token: data.upload && data.upload.token,
    })
  )
  dispatch(setUploading(false))
}

export const submitRequest = form => async (dispatch, getState) => {
  try {
    dispatch(setRequestPending(true))

    const { auth, help } = getState()
    const request = { ...form, uploads: help.uploads }
    const { response } = await api.submitRequest(request, auth.user)

    if (response.ok) {
      alert({
        show: true,
        kind: 'success',
        title: 'Success',
        message: 'Your request has been submitted',
      })(dispatch)
    } else {
      dispatch(submitRequestFailed())
    }

    dispatch(setRequestPending(false))

    return true
  } catch (error) {
    dispatch(submitRequestFailed())
    dispatch(setRequestPending(false))

    return false
  }
}

export function submitRequestFailed() {
  return alert({
    show: true,
    kind: 'danger',
    title: 'Uh oh!',
    message: 'Unable to process request at this time',
  })
}

export const getReleaseNotes = helpLabelOrAppId => async dispatch => {
  try {
    const releaseNotes = await api.getReleaseNotes(helpLabelOrAppId)
    dispatch(setReleaseNotes(releaseNotes))
  } catch (error) {
    console.error(error)
  }
}

const handlers = {
  [SET_ARTICLES]: (state, { articles }) => ({
    ...state,
    articles,
  }),
  [SET_ARTICLES_LOADING]: (state, { articlesLoading }) => ({
    ...state,
    articlesLoading,
  }),
  [SET_QUERY]: (state, { query }) => ({
    ...state,
    query,
  }),
  [SET_UPLOADING]: (state, { uploading }) => ({
    ...state,
    uploading,
  }),
  [ADD_UPLOAD]: (state, { file }) => {
    file.uploadedAt = Date.now()

    return {
      ...state,
      uploads: state.uploads.concat(file),
    }
  },
  [REMOVE_UPLOAD]: (state, { file }) => ({
    ...state,
    uploads: state.uploads.filter(f => f.uploadedAt !== file.uploadedAt),
  }),
  [SET_REQUEST_PENDING]: (state, { requestPending }) => ({
    ...state,
    requestPending,
  }),
  [SET_ARTICLE_ID]: (state, { articleId }) => ({
    ...state,
    articleId,
  }),
  [SET_RELEASE_NOTES]: (state, { releaseNotes }) => ({
    ...state,
    releaseNotes,
  }),
  [SET_SEEN_RELEASE_NOTE_IDS]: (state, { seenReleaseNoteIds }) => ({
    ...state,
    seenReleaseNoteIds,
  }),
}

export const reducer = (state = initialState, action) =>
  handlers[action.type] ? handlers[action.type](state, action) : state

export const selectors = {
  getUnseenReleaseNotesCount: ({ help }) =>
    help.releaseNotes.reduce(
      (count, releaseNote) =>
        help.seenReleaseNoteIds.includes(releaseNote.id) ? count : count + 1,
      0
    ),
}



// WEBPACK FOOTER //
// ./~/label-insight-app-shell/src/Application/help/redux.js